import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBrain, FiBarChart3, FiPalette, FiZap } = FiIcons;

const CapabilitiesSection = () => {
  const capabilities = [
    {
      icon: FiBrain,
      title: "AI Training & Supervision",
      text: "סימון תשובות לשיפור רציף (Human-in-the-loop)."
    },
    {
      icon: FiBarChart3,
      title: "אנליטיקה",
      text: "המרות, נטישות, מגמות לפי ערוץ."
    },
    {
      icon: FiPalette,
      title: "מותאם-מותג",
      text: "שפה, ויזואל, כפתורים, מסרים."
    },
    {
      icon: FiZap,
      title: "Workflow חכם",
      text: "n8n, Google Sheets, Zapier, HubSpot ועוד."
    }
  ];

  return (
    <section className="capabilities-section section bg-white">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            יכולות נוספות שמשרדים אוהבים
          </h2>
        </motion.div>
        
        <div className="capabilities-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {capabilities.map((capability, index) => (
            <motion.div
              key={index}
              className="capability-card bg-gradient-to-br from-purple-50 to-blue-50 p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className="icon-wrapper mb-4">
                <SafeIcon 
                  icon={capability.icon} 
                  className="text-3xl text-purple-600"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {capability.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {capability.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;